export const rewardsDescriptionMap = new Map(
  Object.entries({
    Bonus: 'Bonus',
    Cash: 'Cash',
    FreeSpins: 'Free Spins',
    Coins: 'Bonanza Coins',
    InstantWheel: 'Wheel Spins',
  }),
);
